import React from 'react';
import PropTypes from 'prop-types';
import { AccountSelectCard } from 'web-ui-components/lib/finance/accounts';

const fetchAmount = (balances, type) => {
  if (balances) {
    const balance = balances.find((account) => account.type === type);
    return balance ? balance.amount.value * 100 : 0;
  }
  return 0;
};

const fetchAmountInternational = (balances, type) => {
  if (balances) {
    const balance = balances.find((account) => account.type === type);
    return balance ? `${balance.amount.value} ${balance.amount.currency}` : 0;
  }
  return 0;
};

const isCurrencyUK = (balances, type) => {
  if (balances) {
    const balance = balances.find((account) => account.type === type);
    return balance ? balance.amount.currency === 'GBP' : false;
  }
  return false;
};

const returnAccountCard = (account, selectedAccountList, selectedAccounts) => {
  const {
    id: accountId,
    number,
    balances,
    metadata: { display_name: displayName, account_name: accountName },
    product: { name },
  } = account;
  const isBalanceCurrencyUK = isCurrencyUK(balances, 'current');
  const isAvailableCurrencyUK = isCurrencyUK(balances, 'available');
  const [sortcode, accountNumber] = number.split('-');
  return (
    <AccountSelectCard
      accountAvailable={
        isAvailableCurrencyUK ? fetchAmount(balances, 'available') : null
      }
      accountBalance={
        isBalanceCurrencyUK ? fetchAmount(balances, 'current') : null
      }
      accountHolder={accountName}
      accountName={displayName || name}
      accountNumber={accountNumber}
      onClick={() => selectedAccountList(accountId)}
      sortCode={sortcode}
      accountInternationalBalance={
        isAvailableCurrencyUK
          ? null
          : fetchAmountInternational(balances, 'available')
      }
      accountInternationalAvailable={
        isBalanceCurrencyUK
          ? null
          : fetchAmountInternational(balances, 'current')
      }
      isSelected={
        selectedAccounts
          ? selectedAccounts.some(
              (selectedAccount) => selectedAccount === accountId
            )
          : false
      }
    />
  );
};
const AccountCardList = ({
  accountList,
  selectedAccountList,
  selectedAccounts,
}) => (
  <div className="account-pools__list-container">
    {accountList.length > 0 &&
      accountList.map((account, index) => (
        <div
          className="account-pools__item"
          key={`AccountCardList_account-pools__item_${index}`}
        >
          {returnAccountCard(account, selectedAccountList, selectedAccounts)}
        </div>
      ))}
  </div>
);

AccountCardList.propTypes = {
  accountList: PropTypes.array,
  selectedAccountList: PropTypes.func,
  selectedAccounts: PropTypes.array,
  accountList: PropTypes.array.isRequired,
};
AccountCardList.defaultProps = {
  accountList: [],
};
export { AccountCardList };
